export default __webpack_public_path__ + "static/media/ic_section_meal.6f4f37cf.svg";